import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import moment from "moment";
import axios from "axios";
import { ResourceProjectHoursAPIs } from "./ResourceProjectHoursAPI's";
import ResHoursTRangeForm from "../ResHoursTRangeForm";
import SpRoleHoursTable from "../SpRoleHoursTable";
import { UserConsumer } from "../../../UserContext";
import Header from "../../../components/Header";
import { AlertPopups } from "../../../components/AlertPopups";
import { Redirect } from "react-router-dom";
import DevOpsTasksModal from "../../timesheetModule/DevOpsTasksModal";

const ResourceProjectHours = () => {
	let token,
		empId,
		empDepartment,
		empDesignation = null;

	const [startDateCalender, setStartDateOpenCalender] = useState(false);
	const [endDateCalender, setEndDateOpenCalender] = useState(false);
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [employeeList, setEmployeeList] = useState([]);
	const [resourceProjectHours, setResourceProjectHours] = useState([]);
	const [employeeId, setEmployeeId] = useState(null);
	const [isLoaded, setIsLoaded] = useState(false);
	const [totalHours, setTotalHours] = useState();
	const [tableLoader, setTableLoader] = useState(false);
	const [pagerData, setPagerData] = useState(null);
	const [flag, setFlag] = useState(false);
	const [pageNum, setPageNum] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(10);
	const [showExportExcelBtnLoading, setShowExportExcelBtnLoading] =
		useState(false);
	const defaultSorted = [
		{
			dataField: "taskTitle",
			order: "desc",
		},
	];
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	//devOps
	const [devOpsModal, setDevOpsModal] = useState(false);
	const [devOpstaskName, setDevOpstaskName] = useState(null);
	const [devOpsTasksData, setDevOpsTasksData] = useState(null);
	const [devOpsStartDate, setDevOpsStartDate] = useState(null);
	const [devOpsEndDate, setDevOpsEndDate] = useState(null);
	const exportFileHeaders = [
		{ label: "Employee Name", key: "employeeName" },
		{ label: "Employee Designation", key: "employeeDesignaion" },
		{ label: "Task Category", key: "taskCategory" },
		{ label: "Task Title", key: "taskTitle" },
		{ label: "Hours", key: "hours" },
		{ label: "Norm", key: "norm" },
		{ label: "Alloc", key: "alloc" },
	];
	const columns = [
		{
			dataField: "employeeName",
			text: "Employee Name",
			sort: true,
		},
		{
			dataField: "taskCategory",
			text: "Task Category",
			sort: true,
		},
		{
			dataField: "taskTitle",
			text: "Task Title",
			sort: true,
		},
		{
			dataField: "hours",
			text: "Hours",
			sort: true,
		},
		{
			dataField: "norm",
			text: "Norm",
			sort: true,
		},
		{
			dataField: "alloc",
			text: "Alloc",
			sort: true,
		},
		{
			dataField: "devOpsHours",
			text: "DevOps Hours",
			sort: true,
			formatter: (cell, row) => {
				return (
					<span>
						{row.devOpsHours != "0" && row.devOpsHours != "0.00" ? (
							<span
								className="devOpsHoursLink"
								onClick={() =>
									onDevOpsClick(row, startDate, endDate)
								}
							>
								{row.devOpsHours}
							</span>
						) : (
							<span>{row.devOpsHours}</span>
						)}
					</span>
				);
			},
		},
	];
	const onDevOpsClick = (values, dateStart, dateEnd) => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		let formattedStartDate = moment(dateStart).format("YYYY-MM-DD");
		let formattedEndDate = moment(dateEnd).format("YYYY-MM-DD");
		if (employeeId.value === 0) {
			//if All employee are selected
			axios
				.get(
					`${ResourceProjectHoursAPIs.GetDevOpsTasks}?EmployeeId=${values.employeeId}&ProjectName=${values.taskTitle}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`,
					{
						headers: headers,
					}
				)
				.then((res) => {
					if (res.status === 200) {
						let devOpsData = res.data.sort((a, b) =>
							a.changedDateTime.localeCompare(b.changedDateTime)
						);
						setDevOpstaskName(values.taskTitle);
						setDevOpsTasksData(devOpsData.reverse());
						setDevOpsStartDate(formattedStartDate);
						setDevOpsEndDate(formattedEndDate);
						setDevOpsModal(true);
					}
				});
		} else
			axios
				.get(
					`${ResourceProjectHoursAPIs.GetDevOpsTasks}?EmployeeId=${employeeId.value}&ProjectName=${values.taskTitle}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`,
					{
						headers: headers,
					}
				)
				.then((res) => {
					if (res.status === 200) {
						let devOpsData = res.data.sort((a, b) =>
							a.changedDateTime.localeCompare(b.changedDateTime)
						);
						setDevOpstaskName(values.taskTitle);
						setDevOpsTasksData(devOpsData.reverse());
						setDevOpsStartDate(formattedStartDate);
						setDevOpsEndDate(formattedEndDate);
						setDevOpsModal(true);
					}
				});
	};
	const startDateHandleChange = (date) => {
		setStartDate(date);
	};
	const endDateHandleChange = (date) => {
		setEndDate(date);
	};
	const startDateOpenCalendar = () => {
		if (startDateCalender) {
			setStartDateOpenCalender(false);
		} else {
			setStartDateOpenCalender(true);
		}
	};

	const endDateOpenCalendar = () => {
		if (endDateCalender) {
			setEndDateOpenCalender(false);
		} else {
			setEndDateOpenCalender(true);
		}
	};
	useEffect(() => {
		setStartDate(moment(new Date()).subtract(30, "days")._d);
		setEndDate(moment(new Date())._d);
		getEmployeeList();
	}, []);
	const getEmployeeList = () => {
		if (
			empDepartment === "5" || //Accounts
			empDepartment === "9" || //Admin
			empDesignation?.toString() === "4" || //CM
			empId?.toString() === "180" //Abdullah
		) {
			axios
				.get(`${ResourceProjectHoursAPIs.GetEmployeeList}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					const empList = data;
					empList.sort((a, b) => a.name.localeCompare(b.name));
					empList.unshift({ employeeId: 0, name: "All" });
					setEmployeeList(empList);
				});
		} else {
			axios
				.get(
					`${ResourceProjectHoursAPIs.GetSupervisorsEmployeesList}`,
					{
						headers: { Authorization: `Bearer ${token}` },
					}
				)
				.then(({ data }) => {
					const empList = data;
					empList.sort((a, b) => a.name.localeCompare(b.name));
					empList.unshift({ employeeId: 0, name: "All" });
					setEmployeeList(empList);
				});
		}
	};
	const allEmployees = employeeList.map((list) => {
		return { value: list.employeeId, label: list.name };
	});

	const getEmpId = (obj) => {
		setEmployeeId(obj);
	};
	const getEmployeeProjectHours = (e) => {
		e.preventDefault();

		if (employeeId != null) {
			setIsLoading(true);
			axios
				.get(
					`${
						ResourceProjectHoursAPIs.GetEmployeeProjectHours
					}?EmployeeId=${employeeId.value}&StartDate=${moment(
						startDate
					).format("YYYY MM DD")}&EndDate=${moment(endDate).format(
						"YYYY MM DD"
					)}&SortBy=asc`,
					{ headers: { Authorization: `Bearer ${token}` } }
				)
				.then((res) => {
					setIsLoading(false);
					setResourceProjectHours(res.data["resourceProjectHours"]);
					setTotalHours(res.data.totalHours);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setIsLoaded(true);
					setFlag(true);
					setTableLoader(true);
				})
				.catch((err) => {
					if (err.response.data) {
						AlertPopups.ErrorAlert.fire({
							text: `${err.response.data.message}`,
						});
					}
				});
		} else
			AlertPopups.ErrorAlert.fire({
				text: "Please Select Employee",
			});
	};
	const exportToExcel = (e) => {
		e.preventDefault();
		setShowExportExcelBtnLoading(true);
		employeeId
			? axios({
					url: `${
						ResourceProjectHoursAPIs.ExportToExcel
					}?EmployeeId=${employeeId.value}&StartDate=${moment(
						startDate
					).format("yyyy-MM-DD")}&EndDate=${moment(endDate).format(
						"yyyy-MM-DD"
					)}`,
					method: "GET",
					responseType: "blob",
					headers: {
						Authorization: `Bearer ${token}`,
					},
			  })
					.then((response) => {
						const url = window.URL.createObjectURL(
							new Blob([response.data])
						);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute(
							"download",
							"ResourceProjectHours.xlsx"
						);
						document.body.appendChild(link);
						link.click();
						setShowExportExcelBtnLoading(false);
					})
					.catch((err) => {
						setShowExportExcelBtnLoading(false);
						if (err.response.data) {
							AlertPopups.ErrorAlert.fire({
								text: "Please Select Employee",
							});
						}
					})
			: AlertPopups.ErrorAlert.fire({
					text: "Please Select Employee",
			  });
	};
	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		if (type === "sort" || type === "pagination") {
			if (empId != null) callAPI(type, { page, sortOrder, sortField });
		}
	};
	const callAPI = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let getData = false;
		let apiURL = "";
		if (type === "sort") {
			apiURL = `${
				ResourceProjectHoursAPIs.GetEmployeeProjectHours
			}?EmployeeId=${employeeId.value}&StartDate=${moment(
				startDate
			).format("YYYY MM DD")}&EndDate=${moment(endDate).format(
				"YYYY MM DD"
			)}&SortBy=${sortField}_${sortOrder}&PageNumber=${page}&PageSize=${numberOfItemsPerPage}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${
				ResourceProjectHoursAPIs.GetEmployeeProjectHours
			}?EmployeeId=${employeeId.value}&StartDate=${moment(
				startDate
			).format("YYYY MM DD")}&EndDate=${moment(endDate).format(
				"YYYY MM DD"
			)}&SortBy=${sortBy.dataField}_${
				sortBy.order
			}&PageNumber=${page}&PageSize=${numberOfItemsPerPage}`;

			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					if (res.status === 200) {
						setResourceProjectHours(
							res.data["resourceProjectHours"]
						);
						setTotalHours(res.data.totalHours);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setIsLoaded(true);
						setFlag(true);
						setTableLoader(true);
						setIsLoading(false);
						setPageNum(page);
					}
				});
		}
	};
	const receiveData = (PageSize) => {
		setIsLoading(true);
		axios
			.get(
				`${
					ResourceProjectHoursAPIs.GetEmployeeProjectHours
				}?EmployeeId=${employeeId.value}&StartDate=${moment(
					startDate
				).format("YYYY MM DD")}&EndDate=${moment(endDate).format(
					"YYYY MM DD"
				)}&SortBy=${sortBy.dataField}_${
					sortBy.order
				}&PageNumber=${1}&PageSize=${PageSize}`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then((res) => {
				setResourceProjectHours(res.data["resourceProjectHours"]);
				setTotalHours(res.data.totalHours);
				setPagerData(JSON.parse(res.headers["x-pagination"]));
				setIsLoaded(true);
				setFlag(true);
				setFlag(true);
				setIsLoading(false);
				setPageNum(1);
				setNumberOfItemsPerPage(PageSize);
			});
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empDesignation = userDetails.designation;
				empDepartment = userDetails.department;
				empId = userDetails.id;
				return userDetails.designation.toString() === "4" ||
					userDetails.empRole.includes("2") ||
					userDetails.empRole.includes("5") ||
					userDetails.empRole.includes("3") ? (
					<Container fluid className="container-fluid pl-3 pr-3">
						<Header
							title="Resource Project Hours"
							headerBorder={true}
						/>
						<ResHoursTRangeForm
							startDateOpenCalendar={startDateOpenCalendar}
							endDateOpenCalendar={endDateOpenCalendar}
							startDateCalender={startDateCalender}
							endDateCalender={endDateCalender}
							startDateHandleChange={startDateHandleChange}
							endDateHandleChange={endDateHandleChange}
							startDate={startDate}
							endDate={endDate}
							allEmployees={allEmployees}
							getEmpId={getEmpId}
							clicked={getEmployeeProjectHours}
							data={resourceProjectHours}
							exportToExcel={exportToExcel}
							showBtnLoading={showExportExcelBtnLoading}
							exportFileHeaders={exportFileHeaders}
							isLoading={isLoading}
						/>
						{/*DevOps Task Modal */}
						<DevOpsTasksModal
							showModal={devOpsModal}
							taskName={devOpstaskName}
							devOpsTasksData={devOpsTasksData}
							devOpsDate={devOpsStartDate}
							devOpsEndDate={devOpsEndDate}
							handleClose={() => {
								setDevOpsModal(false);
							}}
						/>
						<SpRoleHoursTable
							tabledata={resourceProjectHours}
							isLoaded={isLoaded}
							pagerData={pagerData}
							columns={columns}
							isLoading={isLoading}
							pageNum={pageNum}
							tableLoader={tableLoader}
							handleTableChange={handleTableChange}
							receiveData={(pageSize) => receiveData(pageSize)}
							flag={flag}
							totalHours={totalHours}
						/>
					</Container>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
};

export default ResourceProjectHours;
